import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=1ecd471f&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
import style0 from "./Login.vue?vue&type=style&index=0&id=1ecd471f&lang=less&scoped=true"
import style1 from "./Login.vue?vue&type=style&index=1&id=1ecd471f&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecd471f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ecd471f')) {
      api.createRecord('1ecd471f', component.options)
    } else {
      api.reload('1ecd471f', component.options)
    }
    module.hot.accept("./Login.vue?vue&type=template&id=1ecd471f&scoped=true", function () {
      api.rerender('1ecd471f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/Login.vue"
export default component.exports